export default "__VITE_ASSET__BhkQLJRd__"